import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";

import { useE2EAgentConfiguration } from "../api/admin";
import { useAuth } from "../auth/AuthContext";

export default function SettingsLayout({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const configuration = useE2EAgentConfiguration();
  return (
    <div className="settings-layout">
      <aside className="settings-sidebar">
        <div className="settings-sidebar__label">Settings</div>
        <nav aria-label="Settings sections">
          <NavLink to="/settings/profile">Profile</NavLink>
          {auth.canManageUsers === true && (
            <NavLink to="/settings/users">Users</NavLink>
          )}
          <NavLink to="/settings/api-tokens">API tokens</NavLink>
          {configuration.data?.client_cli_download_available === true && (
            <NavLink to="/settings/cli">CLI setup</NavLink>
          )}
          <NavLink to="/settings/notifications">Notifications</NavLink>
        </nav>
      </aside>
      <div className="settings-content">{children}</div>
    </div>
  );
}
